<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NHKLoP/tc-custom/9781398405509.jpg?1674925501317" alt="This image is the cover for the book The Wind in the Grass"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Wind in the Grass
      </h1>
      <p class="bookDescription body article font2">
        <p>Life in the village of Hammerwell, situated in a remote part of Salisbury Plain in Wiltshire, England, would appear, on the surface, to be a peaceful rural existence. Set in the period between the two world wars, the order of things is still very much as it has been for hundreds of years. But for Arthur Lever, life suddenly takes a dramatic turn. Set against a background of rural life, seed time, harvest, ploughing and lambing, The Wind in the Grass has lust, romance, cruelty, violence and sudden death. But worst is yet to come for the inhabitants of Hammerwell, insulated from the outside world by the grandeur of The Plain, they are unaware that their lives are about to be devastatingly changed forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Colin Cossor
      </h2>
      
      <p class="authorDescription body article">On  retiring, Colin Cossor studied for a BA in English and an MA in creative writing. After living in North London for 50 years, he has now moved to Suffolk, where he spends his time—when not writing—painting the landscape and walking with Paddy, his Jack Russell Terrier.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c264252